import selfInstantiateOnLoad from "../utilities/instantiateUtility";
const jWindow = window;
export default class fireplaceCatalog {
    constructor() {
        this._body = document.body;
        window.refineSearch = this.refineSearch.bind(this);
        window.changePage = this.changePage.bind(this);
        this._brandSliderContainer = document.querySelector(".brand-main");
        this._applyFilterButton = document.querySelector(".toggle-button-apply");
        this._exitPanelButton = document.querySelector(".toggle-button-X");
        this._filterSection = document.querySelector("#filterSection");
        this._toggleSidebarMobile = document.querySelector("#toggle-sidebar-mobile");
        this._filterPreview = document.querySelector("#applied-filters");
        this._filterPreviewMobile = document.querySelector("#applied-filters__mobile");
        this._headWrapper = document.querySelector(".headerWrapper");
        this._shade = document.querySelector(".shade");
        this._clearFiltersButton = document.querySelector("#clearAllFilters");
        this._clearFiltersMobileButton = document.querySelector("#clearAllFilters__mobile");
        this._multiselectLinks = document.querySelectorAll("[id$='-multiselect'] .multiselect-link");
        this._multiselect = document.querySelectorAll("[id$='-multiselect']");
        this.init();
    }
    init() {
        this.bindToggleEvents();
        this.initializeBrandSlider();
        this.addOtherEvents();
        this.initializeSlick();
    }
    initializeSlick() {
        jWindow.jQuery(".brand-main").show();
        jWindow.jQuery(".brand-main").slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: "60px",
            autoplay: false,
            swipeToSlide: true,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        centerPadding: "40px",
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        centerPadding: "40px",
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        centerPadding: "40px",
                        slidesToShow: 1,
                    },
                },
                {
                    breakpoint: 540,
                    settings: {
                        centerPadding: "40px",
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }
    bindToggleEvents() {
        this._applyFilterButton?.addEventListener("click", () => this._body.classList.toggle("openRefine"));
        this._exitPanelButton?.addEventListener("click", () => this._body.classList.toggle("openRefine"));
        this._shade?.addEventListener("click", () => this._body.classList.toggle("openRefine"));
        this._filterSection?.addEventListener("click", (e) => {
            if (e.target.classList.contains("toggle-sidebar")) {
                this._body.classList.toggle("openRefine");
            }
        });
        this._toggleSidebarMobile?.addEventListener("click", (e) => {
            this._body.classList.toggle("openRefine");
        });
        this._clearFiltersButton?.addEventListener("click", () => (window.location = window.location.pathname));
        this._clearFiltersMobileButton?.addEventListener("click", () => (window.location = window.location.pathname));
    }
    initializeBrandSlider() {
        this._brandSliderContainer.style.display = "block";
    }
    addOtherEvents() {
        this._multiselectLinks?.forEach((link) => {
            link?.addEventListener("click", this.openCloseList.bind(this));
        });
        this._multiselect?.forEach((multiselect) => {
            multiselect?.addEventListener("click", this.inputSelect.bind(this));
        });
        this._headWrapper?.addEventListener("click", this.toggleLists);
        document
            .querySelectorAll("#contentSection .container.hidden-xs .filter_preview, #contentSection .container.hidden-xs .results_preview, #contentSection .visible-xs.margin-top-2x, #contentSection .container.pad-horz-x")
            .forEach((element) => {
            element?.addEventListener("click", this.toggleLists);
        });
        this._filterPreview?.addEventListener("click", this.removeFilter.bind(this));
        this._filterPreviewMobile?.addEventListener("click", this.removeFilter.bind(this));
    }
    openCloseList(e) {
        const target = e.target;
        const tray = target.closest(".multiselect-wrap")?.querySelector("ul");
        this.slideToggle(tray);
        const nextElement = target.nextElementSibling;
        nextElement.style.display =
            nextElement.style.display === "none" ? "block" : "block";
    }
    toggleLists() {
        document.querySelectorAll(".multiselect-wrap").forEach((wrap) => {
            wrap.querySelector("ul").style.display = "none";
            wrap
                .querySelectorAll("a.open")
                .forEach((a) => a.classList.remove("open"));
            wrap.classList.remove("open");
        });
    }
    inputSelect(e) {
        const target = e.target;
        if (target.tagName.toLowerCase() === "li") {
            const filter = target
                .querySelector("input[type='checkbox']")
                .getAttribute("data-filter");
            const input = document.querySelector(`[data-filter="${filter}"]`);
            const checksIcon = input.parentElement.querySelector(".fa");
            if (input.checked) {
                input.checked = false;
                checksIcon.classList.remove("fa-check-square");
                checksIcon.classList.add("fa-square");
                input.parentElement.setAttribute("data-dotagging-element-state", "active");
                input.parentElement.setAttribute("data-dotagging-event-action-result", "check");
            }
            else {
                input.checked = true;
                checksIcon.classList.remove("fa-square");
                checksIcon.classList.add("fa-check-square");
                input.parentElement.setAttribute("data-dotagging-element-state", "inactive");
                input.parentElement.setAttribute("data-dotagging-event-action-result", "uncheck");
            }
        }
        else if (["i", "span", "label"].includes(target.tagName.toLowerCase())) {
            e.preventDefault();
            let filter;
            if (target.tagName.toLowerCase() === "input") {
                filter = target.getAttribute("data-filter");
            }
            else {
                const inputSibling = target
                    .closest("label")
                    ?.querySelector("input[type='checkbox']");
                filter = inputSibling ? inputSibling.getAttribute("data-filter") : null;
            }
            if (filter != null) {
                const input = document.querySelector(`[data-filter="${filter}"]`);
                const checksIcon = input.parentElement.querySelector(".fa");
                if (input.checked) {
                    input.checked = false;
                    checksIcon.classList.remove("fa-check-square");
                    checksIcon.classList.add("fa-square");
                    input.parentElement.setAttribute("data-dotagging-element-state", "active");
                    input.parentElement.setAttribute("data-dotagging-event-action-result", "check");
                }
                else {
                    input.checked = true;
                    checksIcon.classList.remove("fa-square");
                    checksIcon.classList.add("fa-check-square");
                    input.parentElement.setAttribute("data-dotagging-element-state", "inactive");
                    input.parentElement.setAttribute("data-dotagging-event-action-result", "uncheck");
                }
            }
        }
        else {
            e.preventDefault();
        }
    }
    refineSearch() {
        const appliedFilters = function () {
            const keyValues = {};
            const selected = document.querySelectorAll("input[type='checkbox'][id^='refine-search']:checked, input[type='checkbox'][id^='slideout-checkbox']:checked");
            selected.forEach((e) => {
                const key = e.name == "Price"
                    ? e.value.indexOf("-") === -1
                        ? "tier"
                        : "msrp"
                    : e.name;
                const value = encodeURIComponent(e.value);
                if (key in keyValues) {
                    if (keyValues[key].indexOf(value) === -1) {
                        keyValues[key].push(value);
                    }
                }
                else {
                    keyValues[key] = [value];
                }
            });
            return keyValues;
        };
        // DEV-14659 - Changing location.href will not reload the window if there is a fragment
        // If there is a # then remove that portion of the URL starting at the # (just need to take care of fragments)
        let currentUrl = location.href;
        if (currentUrl.includes("#")) {
            currentUrl = currentUrl.substring(0, currentUrl.indexOf("#"));
        }
        location.href = this.updateQueryStringParameters(currentUrl, appliedFilters());
    }
    updateQueryStringParameters(uri, keyValueDict) {
        for (const key in keyValueDict) {
            if (Object.prototype.hasOwnProperty.call(keyValueDict, key)) {
                const value = keyValueDict[key];
                uri = this.updateQueryStringParameter(uri, key, value);
            }
        }
        return uri;
    }
    updateQueryStringParameter(uri, key, value) {
        const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        const separator = uri.indexOf("?") !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri
                .replace(re, "$1" + key + "=" + value + "$2")
                .replace(/pt=\d+&?/i, "");
        }
        else {
            return (uri + separator + key + "=" + value).replace(/pt=\d+&?/i, "");
        }
    }
    removeFilter(element) {
        const target = element.target;
        if (!target.classList.contains("removeFilter"))
            return;
        const qs = this.GetQueryString();
        const el = { event: element, keyValues: {} };
        // Assuming qs is an object with keys and values
        Object.entries(qs).forEach(([key, value]) => {
            if (target.dataset.refinement.toLowerCase() === key.toLowerCase()) {
                value = value.replace("," + target.dataset.filter, "");
                value = value.replace(target.dataset.filter + ",", "");
                value = value.replace(target.dataset.filter, "");
            }
            const filterList = value
                .split(",")
                .filter((item) => item.trim() !== "");
            if (filterList.length > 0) {
                filterList.forEach((v) => {
                    if (key in el.keyValues) {
                        el.keyValues[key].push(v);
                    }
                    else {
                        el.keyValues[key] = [v];
                    }
                });
            }
        });
        location.href = this.updateQueryStringParameters(window.location.pathname, el.keyValues);
    }
    GetQueryString() {
        let match;
        const pl = /\+/g; // Regex for replacing addition symbol with a space
        const search = /([^&=]+)=?([^&]*)/g;
        const decode = function (s) {
            return decodeURIComponent(s.replace(pl, " "));
        };
        const query = window.location.search.substring(1);
        const urlParams = {};
        while ((match = search.exec(query))) {
            urlParams[decode(match[1])] = decode(match[2]);
        }
        return urlParams;
    }
    changePage(pageNumber) {
        let currentUrl = location.href;
        if (currentUrl.includes("#")) {
            currentUrl = currentUrl.substring(0, currentUrl.indexOf("#"));
        }
        const re = new RegExp("([?&])" + "pt" + "=.*?(&|$)", "i");
        const separator = currentUrl.indexOf("?") !== -1 ? "&" : "?";
        if (currentUrl.match(re)) {
            location.href = currentUrl.replace(re, "$1" + "pt" + "=" + pageNumber + "$2");
        }
        else {
            location.href = currentUrl + separator + "pt" + "=" + pageNumber;
        }
    }
    slideUp(element, duration) {
        element.style.height = element.offsetHeight + "px";
        element.style.transitionProperty = "height, margin, padding";
        element.style.transitionDuration = duration + "ms";
        element.style.boxSizing = "border-box";
        element.style.overflow = "hidden";
        setTimeout(() => {
            element.style.height = "0";
            element.style.paddingTop = "0";
            element.style.paddingBottom = "0";
        }, 10);
        setTimeout(() => {
            element.style.display = "none";
            element.style.removeProperty("height");
            element.style.removeProperty("padding-top");
            element.style.removeProperty("padding-bottom");
            element.style.removeProperty("transition-duration");
            element.style.removeProperty("transition-property");
            // Reset overflow property if needed
        }, duration);
    }
    slideDown(element, duration) {
        // Temporarily display the element to measure its full height
        element.style.display = "block";
        const fullHeight = element.offsetHeight + "px";
        element.style.height = "0";
        element.style.paddingTop = "0";
        element.style.paddingBottom = "0";
        element.style.overflow = "hidden";
        element.style.transitionProperty = "height, margin, padding";
        element.style.transitionDuration = duration + "ms";
        element.style.boxSizing = "border-box";
        setTimeout(() => {
            element.style.height = fullHeight;
            element.style.removeProperty("padding-top");
            element.style.removeProperty("padding-bottom");
        }, 10);
        // After the transition, reset styles
        setTimeout(() => {
            this.resetStyle(element);
        }, duration);
    }
    slideToggle(element, duration = 300) {
        // Determine if the element is currently visible
        const isVisible = element.offsetHeight > 0;
        const anchor = element.previousElementSibling;
        if (isVisible) {
            this.slideUp(element, duration);
            anchor.classList.remove("open");
        }
        else {
            document
                .querySelectorAll(".multiselect-wrap ul")
                ?.forEach((ul) => (ul.style.display = "none"));
            document
                .querySelectorAll(".multiselect-wrap a.open")
                ?.forEach((a) => a.classList.remove("open"));
            document
                .querySelectorAll(".multiselect-wrap")
                ?.forEach((wrap) => wrap.classList.remove("open"));
            this.slideDown(element, duration);
            anchor.classList.add("open");
        }
    }
    resetStyle(element) {
        element.style.removeProperty("height");
        element.style.removeProperty("padding-top");
        element.style.removeProperty("padding-bottom");
        element.style.removeProperty("transition-duration");
        element.style.removeProperty("transition-property");
        element.style.removeProperty("overflow");
    }
}
selfInstantiateOnLoad(fireplaceCatalog);
